<div class="side-panel-order-items">
  <div class="side-panel-order-items__banners">
    <!-- WARNING BANNER -->
    @if (order?.updateType?.length || order?.updateTypeV2?.length) {
      <fulfill-side-panel-update-banner [order]="order"></fulfill-side-panel-update-banner>
    }
    @if (order.pendingUpdates?.length) {
      <pending-updates-warning
        id="pending-updates-warning"
        (onOrdersUpdated)="handleOrdersUpdated($event)"
        [orders]="[order]"></pending-updates-warning>
    }
    <br />
    <!-- ADDED TO BATCH BANNER -->
    @if (order.deliveryTransaction?.isAddedToBatch) {
      <pdq-banner
        variant="regular"
        bannerTitle="Order {{ order.orderNumber }}{{
          order.splitted ? '-' + orderSplitIndices : ''
        }} added to batch"></pdq-banner>
    }
  </div>
  <div [class.disabled]="hasPendingUpdates">
    <div class="side-panel-order-items__scan">
      @if (showOrderPackage) {
        <span class="order-package"
          ><pdq-icon icon="box"></pdq-icon>Package: {{ packageName }}
          @if (carrierSupportsSwitchPackage) {
            <pdq-button
              variant="ghost"
              size="medium"
              icon="edit-1"
              iconColor="var(--on-surface-light)"
              (onClick)="switchPackage()">
            </pdq-button>
          }
        </span>
      }
      @if (accessoryItemSku || isOnlyAccessoryItem) {
        <div class="accessory-item-sku">
          <h2>Scan accessory to mark as fulfilled</h2>
          <p>
            <span class="input">
              <pdq-input
                placeholder="Scan Barcode/SKU"
                [disabled]="(order | isBundleRowPipe) || disableActions || (!enableAccessory && !isOnlyAccessoryItem)"
                [value]="scannedAccessory"
                [autofocus]="!disableActions && enableAccessory"
                (onEnter)="scanAccessory()"
                #scanAccessoryInput></pdq-input>
            </span>
            <pdq-button
              class="side-panel-order-items__scan__btn"
              icon="scan"
              variant="dark"
              label="Update"
              [disabled]="(order | isBundleRowPipe) || disableActions || (!enableAccessory && !isOnlyAccessoryItem)"
              (onClick)="scanAccessory()"></pdq-button>
          </p>
        </div>
      }
      @if (enableMultiItem) {
        <div class="mult-items-sku">
          <h2>Scan SKU to mark as fulfilled</h2>
          <p>
            <span class="input">
              <pdq-input
                placeholder="Scan Barcode/SKU"
                [disabled]="(order | isBundleRowPipe) || disableActions || !isMultiItemPending"
                [value]="scannedMultiItemSku"
                [autofocus]="!disableActions && isMultiItemPending"
                (onEnter)="scanMultiItemSku()"
                #scanMultiItemsSkuInput></pdq-input>
            </span>
            <pdq-button
              class="side-panel-order-items__scan__btn"
              icon="scan"
              variant="dark"
              label="Update"
              [disabled]="(order | isBundleRowPipe) || disableActions || !isMultiItemPending"
              (onClick)="scanMultiItemSku()"></pdq-button>
          </p>
        </div>
      }
      @if (!isOnlyAccessoryItem) {
        <h2>Scan {{ packageScanMode ? 'package' : 'items' }} to mark as fulfilled</h2>
        <p>
          <span class="input">
            <pdq-input
              [placeholder]="packageScanMode ? 'Scan package' : 'Scan Barcode/SKU'"
              [disabled]="
                (order | isBundleRowPipe) ||
                disableActions ||
                (accessoryItemSku && enableAccessory) ||
                (isMultiItemPending && enableMultiItem)
              "
              [value]="scannedSku"
              [autofocus]="!disableActions && !enableAccessory && !enableMultiItem"
              (onEnter)="scanSku()"
              #scan></pdq-input>
          </span>

          <pdq-button
            class="side-panel-order-items__scan__btn"
            icon="scan"
            variant="dark"
            label="Update"
            [disabled]="(order | isBundleRowPipe) || disableActions"
            (onClick)="scanSku()"></pdq-button>
        </p>
      }
    </div>
    <div class="side-panel-order-items__list">
      @if (unfulfilledOrderItemsQuantity) {
        <div class="unfulfilled-status">
          <div class="fulfillment-status">
            <div class="circle"></div>
            Unfulfilled ({{ unfulfilledOrderItemsQuantity }})
          </div>
          @if (!isPickingMode) {
            <pdq-button
              variant="ghost"
              icon="v_icon"
              iconColor="#7e91b1"
              label="Fulfill all items"
              (onClick)="fulfillAll()"
              size="medium"
              [disabled]="disableActions || isDisableManualFulfillment">
            </pdq-button>
          }
          @if (isPickingMode) {
            <pdq-button
              variant="ghost"
              icon="v_icon"
              iconColor="#7e91b1"
              label="Pick all items"
              (onClick)="pickAll()"
              size="medium"
              [disabled]="disableActions">
            </pdq-button>
          }
        </div>
      }
      @for (item of unfulfilledOrderItems; track item) {
        <fulfill-side-panel-order-item-card
          class="side-panel-order-items__list__card"
          [order]="order"
          [disableActions]="disableActions"
          [orderItem]="item"
          [itemPicked]="isPickingMode && item.internalStatus === InternalOrderItemStatus.PICKED"
          [itemPartiallyPicked]="
            isPickingMode &&
            item.internalStatus === InternalOrderItemStatus.PARTIALLY_PICKED &&
            item.pickableQuantity < item.quantity &&
            item.pickableQuantity > 0
          "
          [isDigital]="item.requiresShipping === false"
          [isPickAndPackFocus]="isPickAndPackFocus"
          [includeAccessory]="accessoryItemSku"
          [includeMultiItemsOrder]="enableMultiItem"
          (onChange)="!isPickingMode ? checkAutoFulfill() : checkAutoPick()"
          #itemCard></fulfill-side-panel-order-item-card>
      }
      <div>
        <div class="fulfillment-status fulfilled">
          <pdq-icon icon="filled_v1" size="medium" color="#25CEA6"></pdq-icon>
          Fulfilled ({{ fulfilledOrderItemsQuantity }})
        </div>
        @if (!fulfilledOrderItemsQuantity) {
          <div class="no-fulfilled-text">No fulfilled items</div>
        } @else {
          @for (item of fulfilledOrderItems; track item) {
            <fulfill-side-panel-order-item-card
              class="side-panel-order-items__list__card"
              [order]="order"
              [disableActions]="disableActions"
              [orderItem]="item"
              [isDigital]="item.requiresShipping === false"
              [itemFulfilled]="true"
              [isPickAndPackFocus]="isPickAndPackFocus"
              [includeAccessory]="accessoryItemSku"
              (onChange)="checkAutoFulfill()"
              #itemCard></fulfill-side-panel-order-item-card>
          }
        }
      </div>
    </div>
  </div>
</div>
